import { string } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { DateTime } from "luxon";

export function NewFeatureBadge({ dateToHide, ...rest }) {
  const today = DateTime.local();
  const hideDate = DateTime.fromISO(dateToHide);

  if (dateToHide && today >= hideDate) return null;

  return (
    <Div {...rest}>
      NEW <Span />
    </Div>
  );
}

NewFeatureBadge.propTypes = {
  dateToHide: string,
};

const Div = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  text-decoration: none;
  color: #fff;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  background: linear-gradient(to bottom, #1cdb76, #18bb65);
  border-radius: 999px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  user-select: none;
  padding: 2.75px 7px;
  font-size: 0.75rem;
  line-height: 0.75rem;
  margin-left: 2px;
  height: 1.375rem;
  box-sizing: border-box;

  &:before {
    content: "";
    position: absolute;
    z-index: -1;
    background: linear-gradient(30deg, lighten(#18bb65, 16%) 60%, #fff);
    top: -1px;
    right: -1px;
    bottom: -1px;
    left: -1px;
    border-radius: 999px;
  }
`;

const Span = styled.span`
  width: 25px;
  height: 25px;
  position: absolute;
  top: -12px;
  right: -2px;
  transform: rotate(-20deg);
  filter: blur(0.5px);

  &:before {
    content: "";
    position: absolute;
    width: 1px;
    height: 100%;
    left: 12px;
    background: linear-gradient(
      to bottom,
      transparent,
      hsl(0 100% 100% / 0.7),
      transparent
    );
  }

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    top: 12px;
    background: linear-gradient(
      to left,
      transparent,
      hsl(0 100% 100% / 0.7),
      transparent
    );
  }
`;